module.exports = __webpack_public_path__ + "img/1.d3990583.png";